var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIceHockey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Ice_Hockey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Ice_Hockey",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_ice-hockey_3985661_000000",
    transform: "translate(5.212200, 15.940191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87710139,4.37431525 C12.6111593,4.37431525 15.7542028,3.05626694 15.7542028,2.18715762 C15.7542028,1.31542686 12.6112938,0 7.87710139,0 C3.14290901,0 0,1.31804831 0,2.18715762 C0,3.05888839 3.14028756,4.37431525 7.87710139,4.37431525 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87710139,10.6469588 C12.6111593,10.6469588 15.7542028,9.32891053 15.7542028,8.45980121 L15.7542028,4.08024307 C12.3250859,6.22276894 3.42131974,6.2201475 0,4.08024307 L0,8.45980121 C0,9.33153197 3.14028756,10.6469588 7.87710139,10.6469588 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "np_ice-hockey_3075990_000000",
    transform: "translate(8.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6127808,25.9087549 L4.31862996,25.9087549 C1.9382847,25.9087549 0,27.8454351 0,30.2274121 L0,33.6813429 C0,36.0617031 1.93666801,38 4.31862996,38 L16.2655407,38 C21.3680571,38 22.2957873,36.4924496 23.385601,34.0311301 C23.3936972,34.0116986 23.4034131,33.9906475 23.4098902,33.9712169 L31.4788221,15.7638778 L24.6116284,10.3943668 L17.6127808,25.9087549 Z M25.3417936,8.77175307 L32.199453,14.135046 L33.3458921,11.5474168 L26.5027415,6.19573089 L25.3417936,8.77175307 Z M37.8603486,0.391866939 C37.7016603,0.147355831 37.4279882,0 37.1365283,0 L29.8564573,0 C29.5164098,0 29.2087458,0.199173084 29.0695033,0.508472339 L27.2348525,4.57450999 L34.0680543,9.91831965 L37.925182,1.21302116 C38.0450076,0.945838971 38.0190991,0.636564588 37.8604108,0.392028608 L37.8603486,0.391866939 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceHockey);
export default ForwardRef;